module.exports = __webpack_public_path__ + "static/media/SAI.0ff338a3.png";